module.exports = __webpack_public_path__ + "static/media/icon_1.2f19ec74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/icon_1.svg
// module id = 369
// module chunks = 0